import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@mui/material'
import Icon from 'components/design-system/Icon'

/**
 * Panel Header (Figma 10:1884): icon (tuỳ chọn) + title Heading/16 Bold + action / nút close.
 * `closeIcon` / `closeLabel` đổi icon của nút close (vd. `arrow_back` cho nút quay lại).
 */
const PanelHeader = ({ title, icon, action, onClose, closeIcon = 'close', closeLabel = 'Close', sx, ...props }) => (
  <Box
    sx={[
      {
        display: 'flex',
        alignItems: 'center',
        flexShrink: 0,
        gap: 'var(--space-8)',
        width: '100%',
        height: 40,
        px: 'var(--space-16)',
        py: 'var(--space-8)'
      },
      ...(Array.isArray(sx) ? sx : [sx])
    ]}
    {...props}
  >
    {icon && <Icon name={icon} color="var(--color-icon-default)" />}
    <Box
      component="h2"
      sx={{
        flex: '1 0 0',
        minWidth: 0,
        m: 0,
        fontFamily: 'var(--font-family-primary)',
        fontWeight: 'var(--font-weight-bold)',
        fontSize: 'var(--font-size-16)',
        lineHeight: 'normal',
        color: 'var(--color-text-primary)',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
      }}
    >
      {title}
    </Box>
    {action}
    {onClose && (
      <Box
        component="button"
        type="button"
        aria-label={closeLabel}
        onClick={onClose}
        sx={{
          display: 'flex',
          flexShrink: 0,
          p: 0,
          border: 0,
          background: 'none',
          cursor: 'pointer',
          color: 'var(--color-icon-default)',
          '&:hover': { color: 'var(--color-icon-strong)' },
          '&:focus-visible': { outline: '2px solid var(--color-border-focus)', outlineOffset: '2px' }
        }}
      >
        <Icon name={closeIcon} />
      </Box>
    )}
  </Box>
)

PanelHeader.propTypes = {
  title: PropTypes.node,
  icon: PropTypes.string,
  action: PropTypes.node,
  onClose: PropTypes.func,
  closeIcon: PropTypes.string,
  closeLabel: PropTypes.string,
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
}

export default PanelHeader
